// extracted by mini-css-extract-plugin
export default {"spinnerLoader":"SpinnerLoader_spinnerLoader__BOB+S","loader":"SpinnerLoader_loader__snSOY","rotation":"SpinnerLoader_rotation__C-c4R"};